import axios from 'axios';

const FUNCTIONS_URL = 'https://us-central1-modern-tribe-f1e3f.cloudfunctions.net';
// const FUNCTIONS_URL = 'http://127.0.0.1:5001/modern-tribe-f1e3f/us-central1';

// Contact-form message -> emailed to the organisers by the sendContact function.
export const sendContact = (type, fields) =>
  axios.post(
    `${FUNCTIONS_URL}/sendContact`,
    { data: { type, ...fields } },
    { headers: { 'Content-Type': 'application/json' } },
  );

// Registration form -> saved to the sheet and emailed by the submitPayment function.
export const submitApplication = async (data) => {
  const res = await axios.post(
    `${FUNCTIONS_URL}/submitPayment`,
    { data },
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.data;
};
